export default __webpack_public_path__ + "static/media/systemHangers3.11b2bc59.jpg";